import React from 'react';

const CopyIcon = (props: any) => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11.4801 5.32007H6.44007C5.82151 5.32007 5.32007 5.82151 5.32007 6.44007V11.4801C5.32007 12.0986 5.82151 12.6001 6.44007 12.6001H11.4801C12.0986 12.6001 12.6001 12.0986 12.6001 11.4801V6.44007C12.6001 5.82151 12.0986 5.32007 11.4801 5.32007Z"
      stroke={props?.stroke || '#8A3196'}
      strokeWidth="1.05"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.08015 8.6799H2.52015C2.2231 8.6799 1.93823 8.5619 1.72819 8.35186C1.51815 8.14182 1.40015 7.85694 1.40015 7.5599V2.5199C1.40015 2.22286 1.51815 1.93798 1.72819 1.72794C1.93823 1.5179 2.2231 1.3999 2.52015 1.3999H7.56015C7.85719 1.3999 8.14207 1.5179 8.35211 1.72794C8.56215 1.93798 8.68015 2.22286 8.68015 2.5199V3.0799"
      stroke={props?.stroke || '#8A3196'}
      strokeWidth="1.05"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CopyIcon;
